import { stringifyFptiProps } from '@/utils/fpti'
import { commonProperties } from '../../fpti'

export const EDIT_PROFILE_PANEL_NEXT_BUTTON_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'edit_bp_page_next_button_click',
})

export const EDIT_PROFILE_PANEL_EDIT_PROFILE_PHOTO_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'edit_bp_page_edit_profile_photo_click',
})

export const EDIT_PROFILE_PANEL_EDIT_COVER_PHOTO_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'edit_bp_page_edit_cover_photo_click',
})
